import { type ResourceContainer } from "../../gql-generated/types";
import { type OrganizationContainer } from "../models";

type ContainerUnion = OrganizationContainer | ResourceContainer;

export const sortOrganizationContainers =
    (defaultOrgId: string | undefined) =>
    <T extends ContainerUnion>(organizationContainers: T[]): T[] =>
        organizationContainers.sort((a, b) => {
            if (defaultOrgId) {
                if (a.id === defaultOrgId) {
                    return -1;
                } else if (b.id === defaultOrgId) {
                    return 1;
                }
            }
            return a.name.localeCompare(b.name);
        });
